import React from 'react'
import { MdOutlineKeyboardBackspace } from "react-icons/md"
import "./GalleryNav.scss";
import { Container } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import mete from "../images/logos/mete&design_long_text.png"

function GalleryNav() {
    const History = useHistory();
    return (
        <Navbar expand="lg" className=" transparent" fixed="top"  >
            <div className='back'>

                <Container className='nvu'>
                    <MdOutlineKeyboardBackspace className='BackBtn' onClick={() => { History.goBack() }} />
                    < Link to={"/"} style={{ textDecoration: 'none' }}><img style={{ maxWidth: '150px', paddingRight: '10px' }} src={mete} alt='brand logo' /></Link>
                </Container>

            </div>
        </Navbar>
    )
}

export default GalleryNav
